<div class="contact-modal">
  <div class="contact-modal-header">
    <h2>Contact Details</h2>
 
    <button
      type="button"
      class="close-icon"
      aria-label="Close"
      (click)="closeModal()"
    >
      &times;
    </button>
  </div>
 
  <form [formGroup]="contactForm" (ngSubmit)="submit()">
    <div class="contact-modal-body">
      <p class="modal-description">
        To help us process your return request, please provide your contact
        details. We’ll only contact you if additional information is needed.
      </p>
 
      <div class="form-field">
        <label for="firstName">First Name<span>*</span></label>
        <input
          id="firstName"
          type="text"
          formControlName="firstName"
          placeholder="John"
        />
        <small *ngIf="contactForm.get('firstName')?.touched &&
                      contactForm.get('firstName')?.invalid">
          First Name is required.
        </small>
      </div>
 
      <div class="form-field">
        <label for="lastName">Last Name<span>*</span></label>
        <input
          id="lastName"
          type="text"
          formControlName="lastName"
          placeholder="Doe"
        />
        <small *ngIf="contactForm.get('lastName')?.touched &&
                      contactForm.get('lastName')?.invalid">
          Last Name is required.
        </small>
      </div>
 
      <div class="form-field">
        <label for="emailId">Email Id<span>*</span></label>
        <input
          id="emailId"
          type="email"
          formControlName="emailId"
          placeholder="john.doe@bakerhughes.com"
        />
        <small *ngIf="contactForm.get('emailId')?.touched &&
                      contactForm.get('emailId')?.invalid">
          Enter a valid email address.
        </small>
      </div>
 
      <div class="form-field">
        <label for="contactNumber">Contact Number<span>*</span></label>
        <input
          id="contactNumber"
          type="tel"
          formControlName="contactNumber"
          placeholder="+91 9999 9999"
        />
        <small *ngIf="contactForm.get('contactNumber')?.touched &&
                      contactForm.get('contactNumber')?.invalid">
          Contact Number is required.
        </small>
      </div>
 
      <div class="terms-field">
        <input
          id="termsAccepted"
          type="checkbox"
          formControlName="termsAccepted"
        />
 
        <label for="termsAccepted">
          I agree to the
          <a href="https://www.bakerhughesds.com/sales-terms-conditions" target="_blank">
            Terms &amp; Conditions
          </a>
        </label>
      </div>
 
      <small
        class="terms-error"
        *ngIf="contactForm.get('termsAccepted')?.touched &&
               contactForm.get('termsAccepted')?.invalid"
      >
        Please accept the Terms &amp; Conditions.
      </small>
    </div>
 
    <div class="contact-modal-footer">
      <button type="button" class="btn-close" (click)="closeModal()">
        Close
      </button>
 
      <button type="submit" class="btn-submit">
        Submit
      </button>
    </div>
  </form>
</div>